import axios from 'axios';
import { API_HOST } from '../constants/constants';
import useCurrentUser from '../hooks/useCurrentUser';
import { BenefitDetailsContext } from '../contexts/BenefitDetailsContext';

export const getMealOptions = async (benefitID) => {
  const { userID, token } = useCurrentUser();
  const apiURL = `${API_HOST}/orders/boxes?user_id=${userID}&benefit_id=${benefitID}`;

  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'x-dqpn-user-id': userID,
      },
    });

    // console.log('here is the data from getMealOptions: ', data);
    return data;
  } catch (error) {
    console.error('Error fetching meal options:', error);
    return null;
  }
};
